
import { SistemaMixin } from "@/modules/Application";

export default {
  mixins: [SistemaMixin],
  name: "InfoBox",
  props: {
    cor: String,
    titulo: String,
    icone: String,
    valor: Number,
    liquido: Number,
    clientes: Number,
    cobrancas: Number,
    tituloBIcon: String,
  },
};
